<div style="position:relative">
  <div class="availability-container clickable" (click)="openPanel = !openPanel">
    <div class="availability-title">{{'bikeshop.calendar.availability.availability' | translate}}</div>
    <!-- <div *ngFor="let date of eventDates" style="flex: 1">
      <div class="date-container" *ngIf="getAvailability(date)" [ngClass]="{'status-no-time': getAvailability(date).availability === 0, 'status-limited-time': getAvailability(date).availability <= 120 && getAvailability(date).availability > 0, 'status-available-time': getAvailability(date).availability > 120}">
      <div class="date-header">{{getFormattedDay(date)}}</div>
      <div style="display: flex;justify-content: space-between;">
        <div class="label">Avail. Hrs:</div>
        <div>{{(getAvailability(date).availability / 60) | number : '.1-1'}}</div>
      </div>
      <div style="display: flex;justify-content: space-between;" *ngIf="getAvailability(date) && getAvailability(date).dailyValueGoal == 0">
        <div class="label">Sales Goal:</div>
        <div>{{(getAvailability(date).workValue / (getAvailability(date).dailyValueGoal || 1000) * 100) | number : '.1-1'}}%</div>
      </div>
      </div>
    </div> -->
    <div *ngFor="let date of eventDates" style="flex: 1">
      <div class="date-container" *ngIf="getAvailability(date)">
        <div style="display: flex;justify-content: space-around;">
          <div style="display: inline-grid;">
            <div>
              <round-progress
                [current]="(getAvailability(date).availability / getAvailability(date).totalWorkingHours * 100)"
                [max]="100"
                [color]="getAvailability(date).availability > 180 ? '#19c89a' : getAvailability(date).availability <= 180 && getAvailability(date).availability > 0 ? '#ff9752' : '#dc3545'"
                [background]="'#d4d4d4'" [radius]="screenWidth < 1200 ? 22 : 28"
                [stroke]="screenWidth < 1200 ? 4 : 6" [semicircle]="true" [rounded]="true"
                [clockwise]="false" [responsive]="false" [duration]="2000"
                [animation]="'easeInOutQuart'"
                [animationDelay]="0"></round-progress>
              <div class="metric-value" style="font-size: 8px"
                   [ngClass]="{'red': getAvailability(date).availability < 0}">{{getAvailability(date).availability / 60 | number :
                '.1-1' }} Hrs
              </div>
            </div>
            <div>{{'bikeshop.calendar.availability.available' | translate}}</div>
          </div>
          <div style="display: inline-grid;"
               *ngIf="partner.ShowLabourGoals && getAvailability(date).dailyValueGoal && getAvailability(date).dailyValueGoal > 0">
            <div>
              <round-progress [current]="getAvailability(date).totalLabour"
                              [max]="getAvailability(date).dailyValueGoal"
                              [color]="getAvailability(date).totalLabour >= getAvailability(date).dailyValueGoal ? '#19c89a' : getAvailability(date).totalLabour < getAvailability(date).dailyValueGoal && getAvailability(date).totalLabour > (getAvailability(date).dailyValueGoal / 2) ? '#ff9752' : '#dc3545'"
                              [background]="'#d4d4d4'" [radius]="screenWidth < 1200 ? 22 : 28"
                              [stroke]="screenWidth < 1200 ? 4 : 6" [semicircle]="true" [rounded]="true"
                              [clockwise]="false" [responsive]="false" [duration]="2000"
                              [animation]="'easeInOutQuart'"
                              [animationDelay]="0"></round-progress>
            </div>
            <div>{{currencySymbol}} {{'bikeshop.calendar.availability.goal' | translate}}</div>
          </div>
        </div>
        <div style="display: flex;justify-content: space-evenly;">
          <div *ngFor="let technician of technicians; let i = index;"
               [ngClass]="{'faded': getTechnician(date, technician.id) === undefined || getTechnician(date, technician.id) === null || getTechnician(date, technician.id).roundedAvailableTime === 0 }"
               style="position: relative">
            <!-- 'hide': technicians && technicians.length > 6 && (getTechnician(date, technician.id) === undefined || getTechnician(date, technician.id) === null || getTechnician(date, technician.id).roundedAvailableTime === 0)   -->

            <div>
              <avatar [size]="avatarSize" name="{{technician.Name}}"></avatar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="expand-container">
    <div class="expand-button" (click)="openPanel = !openPanel"><span class="fa fa-angle-double-up"></span> </div>
  </div> -->
</div>

<p-sidebar #NavSideBar [(visible)]="openPanel" position="bottom" class="bottom-slider" [showCloseIcon]="false"
           [style]="{ background: '#F6F6F8', height: 'auto'}" (onHide)="NavSideBar.destroyModal()">
  <div *ngIf="openPanel">
    <div class="availability-container clickable" (click)="openPanel = !openPanel">
      <div *ngFor="let date of eventDates" style="flex: 1">
        <div class="date-container" *ngIf="getAvailability(date)">
          <div class="date-header">{{getFormattedDay(date)}}</div>
          <div style="display: flex;justify-content: space-around;margin-top:8px;margin-bottom: 8px;">
            <div style="display: inline-grid;">
              <div>
                <round-progress
                  [current]="(getAvailability(date).availability / getAvailability(date).totalWorkingHours * 100)"
                  [max]="100"
                  [color]="getAvailability(date).availability > 180 ? '#19c89a' : getAvailability(date).availability <= 180 && getAvailability(date).availability > 0 ? '#ff9752' : '#dc3545'"
                  [background]="'#d4d4d4'" [radius]="40" [stroke]="8" [semicircle]="true"
                  [rounded]="true"
                  [clockwise]="false" [responsive]="false" [duration]="2000"
                  [animation]="'easeInOutQuart'"
                  [animationDelay]="0"></round-progress>
                <div class="metric-value">{{getAvailability(date).availability / 60 | number : '.1-1' }}
                  Hrs
                </div>
              </div>
              <div>{{'bikeshop.calendar.availability.available' | translate}}</div>
            </div>
            <div style="display: inline-grid;"
                 *ngIf="partner.ShowLabourGoals && getAvailability(date).dailyValueGoal && getAvailability(date).dailyValueGoal > 0">
              <div>
                <round-progress [current]="getAvailability(date).totalLabour"
                                [max]="getAvailability(date).dailyValueGoal"
                                [color]="getAvailability(date).totalLabour >= getAvailability(date).dailyValueGoal ? '#19c89a' : getAvailability(date).totalLabour < getAvailability(date).dailyValueGoal && getAvailability(date).totalLabour > (getAvailability(date).dailyValueGoal / 2) ? '#ff9752' : '#dc3545'"
                                [background]="'#d4d4d4'" [radius]="40" [stroke]="8" [semicircle]="true"
                                [rounded]="true"
                                [clockwise]="false" [responsive]="false" [duration]="2000"
                                [animation]="'easeInOutQuart'"
                                [animationDelay]="0"></round-progress>
              </div>
              <div>{{currencySymbol}} {{'bikeshop.calendar.availability.goal' | translate}}</div>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 0px;"
               *ngIf="partner.ShowWorkshopTotalsCalendar">
            <div class="label">{{'bikeshop.calendar.availability.workshop_revenue' | translate}}:</div>
            <div style="font-size: 13px;">{{currencySymbol}}{{getAvailability(date).workshopRevenue | number : '.2-2'}}
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 0px;"
               *ngIf="partner.ShowLabourTotalsCalendar">
            <div class="label">{{'bikeshop.calendar.availability.labour_charge' | translate}}:</div>
            <div style="font-size: 13px;">{{currencySymbol}}{{getAvailability(date).totalLabour | number : '.2-2'}}
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 0px;"
               *ngIf="partner.ShowLabourGoals && getAvailability(date).dailyValueGoal > 0">
            <div class="label">{{'bikeshop.calendar.availability.workshop_goal' | translate}}:</div>
            <div style="font-size: 13px;">{{currencySymbol}}{{getAvailability(date).dailyValueGoal | number : '.2-2'}}
            </div>
          </div>

          <div class="technicians-container">
            <div class="technicians-header">
              <div>{{'bikeshop.calendar.availability.technician' | translate}}</div>
              <div>{{'bikeshop.calendar.availability.available_hours' | translate}}</div>
              <div *ngIf="partner.ShowLabourTotalsCalendar">{{'bikeshop.calendar.availability.labour' | translate}}
              </div>
            </div>
            <div *ngFor="let technician of technicians" class="technician-row">
              <div>
                <!-- <avatar size="30" name="{{technician.Name}}"></avatar> -->
                {{technician.Name}}
              </div>
              <div
                [ngClass]="{'green bold': getTechnician(date, technician.id) && getTechnician(date, technician.id).roundedAvailableTime / 60 >= 1}">
                {{(getTechnician(date, technician.id) ? getTechnician(date, technician.id).workingHours === 0 ||
              getTechnician(date, technician.id).adminTime > getTechnician(date, technician.id).workingHours ? 'N/A' :
                (getTechnician(date, technician.id).roundedAvailableTime / 60 | number : '.0-1') + 'Hrs' : 0 + 'Hrs')}}
              </div>
              <div *ngIf="partner.ShowLabourTotalsCalendar"
                   [ngClass]="{'green bold': partner.ShowLabourGoals && getTechnician(date, technician.id) && getTechnician(date, technician.id).totalLabour >= getTechnician(date, technician.id).dailyValueGoal && getTechnician(date, technician.id).dailyValueGoal !== 0}">
                {{currencySymbol}}{{(getTechnician(date, technician.id) ? getTechnician(date, technician.id).totalLabour
                : 0) | number : '.0-0'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-sidebar>
